import { LOCALES } from 'i18n/locales';

export const workpackPrintPreviewIntl = {
    [LOCALES.ENGLISH]: {
        'workpackPrintPreview.title': 'PDF preview',
        'workpackPrintPreview.paperSize': 'Paper size',
        'workpackPrintPreview.scale': 'Scale',
        'workpackPrintPreview.editArea': 'Edit area',
        'workpackPrintPreview.aoiCutoffWarning': 'Drawn area too large for the page. Choose a smaller scale or a larger page size',
        'workpackPrintPreview.selectOptionsPlaceholder': 'Select paper size and map scale to show preview'
    },
    [LOCALES.WELSH]: {
        'workpackPrintPreview.title': '[PDF preview]',
        'workpackPrintPreview.paperSize': '[Paper size]',
        'workpackPrintPreview.scale': '[Scale]',
        'workpackPrintPreview.editArea': '[Edit area]',
        'workpackPrintPreview.aoiCutoffWarning': '[Drawn area too large for the page. Choose a smaller scale or a larger page size]',
        'workpackPrintPreview.selectOptionsPlaceholder': '[Select paper size and map scale to show preview]'
    }
};
